import { FC } from 'react'

import { ModalProps } from 'components/modal'
import { Button, Container, Content, Logos, Modal, Title } from './styled'
import { Logo70Years } from './logo-70-years'
import { Logo } from './logo'

export const WelcomeModal: FC<ModalProps> = ({ onClose, ...props }) => (
  <Modal {...props} fullscreen>
    <Container>
      <Logos>
        <li>
          <Logo70Years />
        </li>
        <li>
          <Logo />
        </li>
      </Logos>
      <Title>
        Радио Свобода: <span>семьдесят лет в эфире</span>
      </Title>
      <Content>
        <p>
          Семь десятилетий российской и мировой истории. От холодной войны до
          войны против Украины. Герои, злодеи, главные фигуры эпохи. Радиоэфир,
          тексты программ, уникальные интервью, архивные фотографии. 70 часовых
          программ. Наша и ваша жизнь. Устами Радио Свобода
        </p>
        <p>
          <Button onClick={onClose}>Лови Свободу</Button>
        </p>
      </Content>
    </Container>
  </Modal>
)
